export const getDashboardPath = (role) => {
  // 1. Jika role kosong/null/undefined, lempar ke landing
  if (!role) {
    console.warn("Role tidak ditemukan/kosong, arahkan ke landing.");
    return "/landing";
  }

  // 2. Jika role berbentuk OBJECT (misal: {id:1, name:'admin'}), ambil properti 'name'
  // Sesuaikan 'name' dengan key di JSON backend Anda (bisa 'slug', 'title', dll)
  let roleName = role;
  if (typeof role === 'object') {
    roleName = role.nama_role || role.name || role.role || "";
  }

  // 3. Pastikan jadi string dan huruf kecil semua (biar admin == Admin)
  const safeRole = String(roleName).toLowerCase().trim();
  
  console.log("Role yang dideteksi sistem:", safeRole); // Cek Console Browser nanti

  switch (safeRole) {
    case "admin":
      return "/admin/dashboard";
      
    case "penyedia":
      return "/penyedia/dashboard";
      
    case "supervisor":
      return "/supervisor/dashboard";
      
    case "sekolah":
      return "/sekolah/dashboard";
      
    default:
      console.warn(`Role '${safeRole}' tidak dikenali, lempar ke landing.`);
      return "/landing";
  }
};